import type { LocaleMessageBundle } from '../../types'

export const saleReturnMessages: LocaleMessageBundle = {
  vi: {
    'saleReturn.settings.enabled': 'Cho phép trả hàng / đổi hàng',
    'saleReturn.settings.days': 'Thời hạn trả hàng (ngày)',
    'saleReturn.settings.daysHint': '0 = không giới hạn thời hạn trả hàng.',
    'saleReturn.title': 'Trả hàng / Đổi hàng',
    'saleReturn.subtitle': 'Quản lý phiếu trả hàng và đổi hàng cho hóa đơn bán ra.',
    'saleReturn.disabled': 'Chức năng trả hàng đang tắt. Vui lòng bật trong Cài đặt hệ thống.',
    'saleReturn.periodExpired': 'Hóa đơn đã quá hạn trả hàng ({days} ngày).',
    'saleReturn.actions.create': 'Thêm mới',
    'saleReturn.actions.update': 'Cập nhật',
    'saleReturn.actions.view': 'Xem chi tiết',
    'saleReturn.actions.complete': 'Hoàn thành',
    'saleReturn.actions.reject': 'Từ chối',
    'saleReturn.actions.cancel': 'Hủy',
    'saleReturn.actions.cancelTitle': 'Hủy phiếu trả hàng',
    'saleReturn.actions.cancelConfirm': 'Hủy',
    'saleReturn.actions.delete': 'Xóa',
    'saleReturn.actions.deleteTitle': 'Xóa phiếu trả/đổi nháp',
    'saleReturn.actions.addExchange': 'Thêm hàng đổi',
    'saleReturn.actions.addRow': 'Thêm dòng',
    'saleReturn.actions.print': 'In phiếu',
    'saleReturn.actions.saveDraft': 'Lưu nháp',
    'saleReturn.actions.saveAndComplete': 'Lưu & hoàn thành',
    'saleReturn.fields.code': 'Mã phiếu',
    'saleReturn.fields.returnDate': 'Ngày trả',
    'saleReturn.fields.type': 'Loại phiếu',
    'saleReturn.fields.sourceType': 'Nguồn',
    'saleReturn.fields.customer': 'Khách hàng',
    'saleReturn.fields.invoice': 'Hóa đơn',
    'saleReturn.fields.branch': 'Chi nhánh',
    'saleReturn.fields.status': 'Trạng thái',
    'saleReturn.fields.reason': 'Lý do',
    'saleReturn.fields.note': 'Ghi chú',
    'saleReturn.fields.paymentMethod': 'Phương thức thanh toán',
    'saleReturn.fields.returnTotal': 'Tổng tiền trả',
    'saleReturn.fields.exchangeTotal': 'Tổng tiền đổi',
    'saleReturn.fields.netAmount': 'Chênh lệch',
    'saleReturn.fields.refundAmount': 'Tiền hoàn khách',
    'saleReturn.fields.customerPay': 'Khách trả thêm',
    'saleReturn.fields.discountTotal': 'Giảm giá SP',
    'saleReturn.fields.invoiceDiscountTotal': 'Giảm giá hoá đơn',
    'saleReturn.fields.vat': 'Thuế VAT',
    'saleReturn.fields.vatWithRate': 'Thuế VAT ({rate}%)',
    'saleReturn.fields.vatAmount': 'Tiền thuế VAT',
    'saleReturn.fields.quantity': 'Số lượng',
    'saleReturn.fields.unitPrice': 'Đơn giá',
    'saleReturn.fields.discount': 'Giảm giá',
    'saleReturn.fields.lineTotal': 'Thành tiền',
    'saleReturn.fields.condition': 'Tình trạng',
    'saleReturn.fields.product': 'Sản phẩm',
    'saleReturn.fields.unit': 'Đơn vị',
    'saleReturn.fields.returnItems': 'Hàng trả lại',
    'saleReturn.fields.exchangeItems': 'Hàng đổi',
    'saleReturn.fields.rejectReason': 'Lý do từ chối',
    'saleReturn.fields.cancelReason': 'Lý do hủy',
    'saleReturn.fields.createdBy': 'Người tạo',
    'saleReturn.fields.createdAt': 'Ngày tạo',
    'saleReturn.fields.completedAt': 'Ngày hoàn thành',
    'saleReturn.fields.locations': 'Vị trí',
    'saleReturn.fields.remainingQuantity': 'Còn có thể trả',
    'saleReturn.fields.invoiceQuantity': 'SL trên hóa đơn',
    'saleReturn.fields.returnedQuantity': 'Đã trả',
    'saleReturn.fields.rejectedReason': 'Lý do từ chối',
    'saleReturn.types.return': 'Trả hàng',
    'saleReturn.types.exchange': 'Đổi hàng',
    'saleReturn.sourceTypes.invoice': 'Theo hóa đơn',
    'saleReturn.sourceTypes.quick': 'Trả nhanh',
    'saleReturn.statuses.draft': 'Nháp',
    'saleReturn.statuses.completed': 'Hoàn thành',
    'saleReturn.statuses.rejected': 'Từ chối',
    'saleReturn.statuses.cancelled': 'Đã hủy',
    'saleReturn.conditions.good': 'Nguyên vẹn',
    'saleReturn.conditions.damaged': 'Hư hỏng',
    'saleReturn.conditions.rejected': 'Không nhận',
    'saleReturn.filters.search': 'Tìm mã phiếu, khách hàng',
    'saleReturn.filters.returnDate': 'Ngày trả',
    'saleReturn.dialog.createTitle': 'Tạo phiếu trả hàng',
    'saleReturn.dialog.editTitle': 'Cập nhật phiếu trả hàng',
    'saleReturn.dialog.detailTitle': 'Chi tiết phiếu trả hàng',
    'saleReturn.dialog.chooseInvoice': 'Chọn hóa đơn',
    'saleReturn.dialog.chooseProduct': 'Tìm sản phẩm',
    'saleReturn.dialog.invoicePlaceholder': 'Tìm theo mã hóa đơn hoặc khách hàng',
    'saleReturn.dialog.productPlaceholder': 'Tìm theo tên hoặc mã sản phẩm',
    'saleReturn.dialog.invoiceDate': 'Ngày hóa đơn',
    'saleReturn.dialog.invoiceTotal': 'Tổng tiền',
    'saleReturn.dialog.selectInvoice': 'Chọn hóa đơn',
    'saleReturn.dialog.dateFrom': 'Từ ngày',
    'saleReturn.dialog.dateTo': 'Đến ngày',
    'saleReturn.dialog.dateRange': 'Khoảng ngày',
    'saleReturn.dialog.tab': 'Đơn {number}',
    'saleReturn.dialog.addTab': 'Thêm đơn',
    'saleReturn.dialog.closeTab': 'Đóng đơn',
    'saleReturn.dialog.noReturnableInvoices': 'Không có hóa đơn nào còn có thể trả.',
    'saleReturn.dialog.invoiceWithoutReturnableItems':
      'Hóa đơn này không còn sản phẩm nào có thể trả.',
    'saleReturn.messages.createSuccess': 'Thêm phiếu trả/đổi hàng thành công',
    'saleReturn.messages.updateSuccess': 'Đã cập nhật phiếu trả hàng.',
    'saleReturn.messages.completeSuccess': 'Đã hoàn thành phiếu trả hàng.',
    'saleReturn.messages.rejectSuccess': 'Đã từ chối phiếu trả hàng.',
    'saleReturn.messages.cancelSuccess': 'Đã hủy phiếu trả hàng.',
    'saleReturn.messages.cancelConfirm': 'Bạn có chắc muốn hủy phiếu {code}?',
    'saleReturn.messages.deleteConfirm': 'Bạn chắc chắn muốn xóa phiếu trả/đổi nháp {code}?',
    'saleReturn.messages.empty': 'Chưa có phiếu trả hàng nào.',
    'saleReturn.messages.totalItems': 'Tổng {total} phiếu',
    'saleReturn.errors.saveFailed': 'Không lưu được phiếu trả hàng.',
    'saleReturn.errors.loadFailed': 'Không tải được dữ liệu phiếu trả hàng.',
    'saleReturn.errors.cancelReasonRequired': 'Vui lòng nhập lý do hủy.',
    'saleReturn.errors.cancelReasonTooLong':
      'Lý do hủy không được vượt quá {max} ký tự.',
    'saleReturn.errors.missingItems': 'Vui lòng chọn ít nhất một sản phẩm.',
    'saleReturn.errors.missingBranch': 'Vui lòng chọn chi nhánh.',
    'saleReturn.errors.quantityRequired': 'Số lượng phải lớn hơn 0.',
    'saleReturn.errors.quantityExceeds': 'Số lượng vượt quá mức có thể trả.',
    'saleReturn.errors.refundInvalid': 'Số tiền hoàn không hợp lệ.',
    'saleReturn.errors.paymentMethodRequired': 'Vui lòng chọn phương thức thanh toán.',
    'saleReturn.errors.rejectReasonRequired': 'Vui lòng nhập lý do từ chối.',
    'saleReturn.errors.invoiceRequired': 'Vui lòng chọn hóa đơn.',
    'saleReturn.errors.quickProductInvalid': 'Sản phẩm không hợp lệ để trả nhanh.',
  },
  en: {
    'saleReturn.settings.enabled': 'Enable returns / exchanges',
    'saleReturn.settings.days': 'Return window (days)',
    'saleReturn.settings.daysHint': '0 = no return time limit.',
    'saleReturn.title': 'Returns / Exchanges',
    'saleReturn.subtitle': 'Manage sales return and exchange slips for invoices.',
    'saleReturn.disabled': 'Returns are disabled. Enable them in System Settings.',
    'saleReturn.periodExpired': 'The invoice is past the return window ({days} days).',
    'saleReturn.actions.create': 'New',
    'saleReturn.actions.update': 'Update',
    'saleReturn.actions.view': 'View detail',
    'saleReturn.actions.complete': 'Complete',
    'saleReturn.actions.reject': 'Reject',
    'saleReturn.actions.cancel': 'Cancel',
    'saleReturn.actions.cancelTitle': 'Cancel return slip',
    'saleReturn.actions.cancelConfirm': 'Cancel',
    'saleReturn.actions.delete': 'Delete',
    'saleReturn.actions.deleteTitle': 'Delete draft return/exchange',
    'saleReturn.actions.addExchange': 'Add exchange item',
    'saleReturn.actions.addRow': 'Add line',
    'saleReturn.actions.print': 'Print',
    'saleReturn.actions.saveDraft': 'Save draft',
    'saleReturn.actions.saveAndComplete': 'Save & complete',
    'saleReturn.fields.code': 'Return code',
    'saleReturn.fields.returnDate': 'Return date',
    'saleReturn.fields.type': 'Type',
    'saleReturn.fields.sourceType': 'Source',
    'saleReturn.fields.customer': 'Customer',
    'saleReturn.fields.invoice': 'Invoice',
    'saleReturn.fields.branch': 'Branch',
    'saleReturn.fields.status': 'Status',
    'saleReturn.fields.reason': 'Reason',
    'saleReturn.fields.note': 'Note',
    'saleReturn.fields.paymentMethod': 'Payment method',
    'saleReturn.fields.returnTotal': 'Return total',
    'saleReturn.fields.exchangeTotal': 'Exchange total',
    'saleReturn.fields.netAmount': 'Difference',
    'saleReturn.fields.refundAmount': 'Refund to customer',
    'saleReturn.fields.customerPay': 'Customer pays',
    'saleReturn.fields.discountTotal': 'Product discount',
    'saleReturn.fields.invoiceDiscountTotal': 'Invoice discount',
    'saleReturn.fields.vat': 'VAT',
    'saleReturn.fields.vatWithRate': 'VAT ({rate}%)',
    'saleReturn.fields.vatAmount': 'VAT amount',
    'saleReturn.fields.quantity': 'Quantity',
    'saleReturn.fields.unitPrice': 'Unit price',
    'saleReturn.fields.discount': 'Discount',
    'saleReturn.fields.lineTotal': 'Line total',
    'saleReturn.fields.condition': 'Condition',
    'saleReturn.fields.product': 'Product',
    'saleReturn.fields.unit': 'Unit',
    'saleReturn.fields.returnItems': 'Returned items',
    'saleReturn.fields.exchangeItems': 'Exchange items',
    'saleReturn.fields.rejectReason': 'Reject reason',
    'saleReturn.fields.cancelReason': 'Cancel reason',
    'saleReturn.fields.createdBy': 'Created by',
    'saleReturn.fields.createdAt': 'Created at',
    'saleReturn.fields.completedAt': 'Completed at',
    'saleReturn.fields.locations': 'Locations',
    'saleReturn.fields.remainingQuantity': 'Returnable',
    'saleReturn.fields.invoiceQuantity': 'Invoice qty',
    'saleReturn.fields.returnedQuantity': 'Returned',
    'saleReturn.fields.rejectedReason': 'Reject reason',
    'saleReturn.types.return': 'Return',
    'saleReturn.types.exchange': 'Exchange',
    'saleReturn.sourceTypes.invoice': 'From invoice',
    'saleReturn.sourceTypes.quick': 'Quick return',
    'saleReturn.statuses.draft': 'Draft',
    'saleReturn.statuses.completed': 'Completed',
    'saleReturn.statuses.rejected': 'Rejected',
    'saleReturn.statuses.cancelled': 'Cancelled',
    'saleReturn.conditions.good': 'Good',
    'saleReturn.conditions.damaged': 'Damaged',
    'saleReturn.conditions.rejected': 'Rejected',
    'saleReturn.filters.search': 'Search code or customer',
    'saleReturn.filters.returnDate': 'Return date',
    'saleReturn.dialog.createTitle': 'Create return slip',
    'saleReturn.dialog.editTitle': 'Update return slip',
    'saleReturn.dialog.detailTitle': 'Return slip detail',
    'saleReturn.dialog.chooseInvoice': 'Choose invoice',
    'saleReturn.dialog.chooseProduct': 'Search product',
    'saleReturn.dialog.invoicePlaceholder': 'Search by invoice code or customer',
    'saleReturn.dialog.productPlaceholder': 'Search by name or code',
    'saleReturn.dialog.invoiceDate': 'Invoice date',
    'saleReturn.dialog.invoiceTotal': 'Total',
    'saleReturn.dialog.selectInvoice': 'Select invoice',
    'saleReturn.dialog.dateFrom': 'From date',
    'saleReturn.dialog.dateTo': 'To date',
    'saleReturn.dialog.dateRange': 'Date range',
    'saleReturn.dialog.tab': 'Order {number}',
    'saleReturn.dialog.addTab': 'Add order',
    'saleReturn.dialog.closeTab': 'Close order',
    'saleReturn.dialog.noReturnableInvoices': 'No invoice is eligible for return.',
    'saleReturn.dialog.invoiceWithoutReturnableItems':
      'This invoice has no products left to return.',
    'saleReturn.messages.createSuccess': 'Return slip created.',
    'saleReturn.messages.updateSuccess': 'Return slip updated.',
    'saleReturn.messages.completeSuccess': 'Return slip completed.',
    'saleReturn.messages.rejectSuccess': 'Return slip rejected.',
    'saleReturn.messages.cancelSuccess': 'Return slip cancelled.',
    'saleReturn.messages.cancelConfirm':
      'Are you sure you want to cancel return slip {code}?',
    'saleReturn.messages.deleteConfirm': 'Delete draft return/exchange slip {code}?',
    'saleReturn.messages.empty': 'No return slips yet.',
    'saleReturn.messages.totalItems': '{total} slips',
    'saleReturn.errors.saveFailed': 'Could not save the return slip.',
    'saleReturn.errors.loadFailed': 'Could not load return slips.',
    'saleReturn.errors.cancelReasonRequired': 'Cancellation reason is required.',
    'saleReturn.errors.cancelReasonTooLong':
      'Cancellation reason cannot exceed {max} characters.',
    'saleReturn.errors.missingItems': 'Please select at least one product.',
    'saleReturn.errors.missingBranch': 'Please select a branch.',
    'saleReturn.errors.quantityRequired': 'Quantity must be greater than 0.',
    'saleReturn.errors.quantityExceeds': 'Quantity exceeds the returnable amount.',
    'saleReturn.errors.refundInvalid': 'Refund amount is invalid.',
    'saleReturn.errors.paymentMethodRequired': 'Please choose a payment method.',
    'saleReturn.errors.rejectReasonRequired': 'Please enter a reject reason.',
    'saleReturn.errors.invoiceRequired': 'Please choose an invoice.',
    'saleReturn.errors.quickProductInvalid': 'This product cannot be returned directly.',
  },
}
